import AppStore from '@v4/store/appStore'
import { useMemo } from 'react'
import { MERGE_TAG_GROUP } from '@v4/hooks/useEditor'
import QUESTION_TYPE from '@v4/constants/questions'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import PageData from '@v4/utils/data/PageData'
import { useStoreState } from 'easy-peasy'

const useLeadAnswerMergeTags = () => {
	const pageType = PageBuilderSelector.useType()
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const builderData = useStoreState(state => state.signups.data)

	return useMemo(() => {
		if (!isBuilderMode || (!PageData.isTypeResult(pageType) && !PageData.isTypeResultPdf(pageType))) {
			return undefined
		}

		const getMergeTagData = ({ ref, question, answer, index, value, answerType }) => {
			const group = `signup_question:${ref}`
			const groups = {
				[group]: {
					title: question,
					order: index + 1,
				},
			}
			const tags = []
			const shortcuts = []

			const questionKey = `signup_question.${ref}.question`
			tags[questionKey] = {
				title: 'Question',
				searchLabel: `Question | ${question}`,
				label: `Question | ${question}`,
				groups: [MERGE_TAG_GROUP.LEAD_FORM_ANSWERS, group],
				order: 1,
			}
			shortcuts[questionKey] = question

			const answerKey = `signup_question.${ref}.answer`
			tags[answerKey] = {
				title: 'Answer',
				searchLabel: `Answer | ${question}`,
				label: `Answer | ${question}`,
				groups: [MERGE_TAG_GROUP.LEAD_FORM_ANSWERS, group],
				order: 2,
			}
			shortcuts[answerKey] = answer

			if (_.includes([QUESTION_TYPE.DROPDOWN, QUESTION_TYPE.COUNTRY, QUESTION_TYPE.INDUSTRY], answerType)) {
				const valueKey = `signup_question.${ref}.answer_value`
				tags[valueKey] = {
					title: 'Value',
					searchLabel: `Value | ${question}`,
					label: `Value | ${question}`,
					groups: [MERGE_TAG_GROUP.LEAD_FORM_ANSWERS, group],
					order: 3,
				}
				shortcuts[valueKey] = value || answer
			}

			return {
				groups,
				tags,
				shortcuts,
			}
		}

		const result = _.filter(builderData, ({ answer_type: type }) => type !== QUESTION_TYPE.CHECKBOX)

		return _.sortBy(result, ['order']).reduce(
			(acc, { ref, question, options, answer_type: answerType }, index) => {
				const answer = _.isEmpty(options) ? `("${question}" answer)` : options[0].option
				const value = _.isEmpty(options) ? `("${question}" value)` : options[0].option_value
				const { groups, tags, shortcuts } = getMergeTagData({ ref, question, answer, index, value, answerType })

				acc.groups = { ...acc.groups, ...groups }
				acc.tags = { ...acc.tags, ...tags }
				acc.shortcuts = { ...acc.shortcuts, ...shortcuts }

				return acc
			},
			{
				tags: {},
				groups: {},
				shortcuts: {},
			},
		)
	}, [builderData, isBuilderMode, pageType])
}

export default useLeadAnswerMergeTags
